import { useMemo, useState } from "react";
import {
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  ListItemIcon,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import EmailIcon from "@mui/icons-material/Email";
import useLocalStorage from "../../hooks/useLocalStorage";
import { useToastSetter } from "../../context/ToastContext";
import { printPdf } from "../../utils/utils";
import API from "../../config/api";

import styles from "./certificateLetterList.module.scss";

export const CertificateLetterList = ({
  memberId,
  membershipPending,
}) => {
  const [storageOrganization] = useLocalStorage("organization", null);
  const [isSending, setIsSending] = useState(false);
  const setToast = useToastSetter();
  const organization = useMemo(
    () => JSON.parse(storageOrganization),
    [storageOrganization]
  );

  async function printLetter() {
    try {
      const pdf = await API.post("member/reference-letter", {
        memberId,
        serviceId: "0",
      });

      printPdf(pdf.letterPdf.data);
    } catch (e) {
      setToast({
        open: true,
        message: "Error al intentar imprimir carta",
        variant: "error",
      });
    }
  }

  async function sendLetterByEmail() {
    try {
      await API.post("member/reference-letter", {
        memberId,
        serviceId: "0",
        sendByEmail: true,
      });
    } catch (e) {
      setToast({
        open: true,
        message: "Error al intentar enviar el correo",
        variant: "error",
      });
    }
  }

  const handleDownload = () => {
    setIsSending(true);
    printLetter();
    setIsSending(false);
    /*
    const url = `${organization.certificateUrl}/certificate_letter_${memberId}_${organization.id}.pdf`;
    console.log("URL---", url);
    window.open(url, "download");
    */
  };

  const handleSendEmail = async () => {
    setIsSending(true);
    sendLetterByEmail();
    /*
      await API.get(
        `member/send_member?template=certificate_letter&member_id=${memberId}`
      );
      */

    setIsSending(false);
  };

  return (
    <>
      <h4>Carta de Certificación</h4>
      {membershipPending > 2 ? (
        <p className={styles.container_warning}>
          Miembro inactivo, no tiene acceso a cartas o certificados
        </p>
      ) : null}
      <List sx={{ width: "100%", maxWidth: 480, bgcolor: "background.paper" }}>
        <ListItem>
          <ListItemText primary="Carta de certificación" />
          <ListItemButton
            role={undefined}
            onClick={handleDownload}
            dense
            disabled={isSending || membershipPending > 2}
          >
            <ListItemIcon>
              Descargar
              <DownloadIcon />
            </ListItemIcon>
          </ListItemButton>
          <ListItemButton
            role={undefined}
            onClick={handleSendEmail}
            dense
            disabled={isSending || membershipPending > 2}
          >
            <ListItemIcon>
              Enviar
              <EmailIcon />
            </ListItemIcon>
          </ListItemButton>
        </ListItem>
      </List>
    </>
  );
};
